import React, { useEffect, useState } from "react";
import DashboardLayout from "../DashboardLayout";

import apiClient from "../../utils/apiClient";
import TableData from "./ShowTableData";
import server from "../../utils/serverConfig";

export default function GreeksComponent() {
  const [data, setData] = useState();

  const fetchOptionGreeks = () => {
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}greeks`,
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response data-------------->", response.data);
        setData(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    fetchOptionGreeks();
  }, []);

  return (
    <DashboardLayout>
      <div className="flex flex-col relative  w-full max-h-screen">
        <div className="flex items-center justify-between space-x-4 ">
          <div className="flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
            <p className="flex items-center text-lg font-semibold text-white">
              Greeks Data Table
            </p>
          </div>
        </div>

        <div className="w-full h-full overflow-hidden ">
          <TableData data={data && data} />
        </div>
      </div>
    </DashboardLayout>
  );
}
